export const wordpressRoot = '/';
export const apiV2 = 'wp-json/wp/v2/'
